export const useTwicPicsBlogUrl = (url: string) => `/blog${url}`
